export const PRODUCT_COMP = 'PRODUCT_COMP';
export const PRODUCT_CREATE_COMP = 'PRODUCT_CREATE_COMP';
export const PRODUCT_EDIT_TEMPORARY_PRICE_COMP = 'PRODUCT_EDIT_TEMPORARY_PRICE_COMP';
